import * as React from 'react';

import { AddressDTO, Res } from 'core/api';
import { deepEquals } from 'core/utils';
import { Button, Flex } from 'core/ui';


export default function DeliveryAddresses(props: {
	currentAddress: Nullable<AddressDTO>,
	deliveryAddresses: AddressDTO[],
	onSelectDeliveryAddress: (address: AddressDTO) => void,
	onAddDeliveryAddress: () => void,
	onRemoveDeliveryAddress: (address: AddressDTO) => void
}): React.ReactNode {
	return <Flex.Vertical>
		<Flex.Item className='m-b-sm text-16'>
			{Res.Web.START_TAKEOUT_ORDER_DELIVERY_ADDRESS_GRP()}
			<Button className='btn-sm pull-right' onClick={props.onAddDeliveryAddress}><i className='text-info fa fa-plus'></i> {Res.Common.ADD_BTN()}</Button>
		</Flex.Item>
		<Flex.Item size='*'>
			<ul className='list'>
				{props.deliveryAddresses.map((address, index) => {
					const isSelected = deepEquals(address, props.currentAddress);
					const selectedClass = isSelected ? 'selected p-xs' : 'p-xs';
					return <li className={selectedClass} key={index} onClick={() => props.onSelectDeliveryAddress(address)}>
						{isSelected && <Button className='btn-sm m-t-n-xs text-danger pull-right' onClick={() => props.onRemoveDeliveryAddress(address)}><i className='fa fa-trash-o'></i> {Res.Common.DELETE_BTN()}</Button>}
						{`${address.Street} - ${address.ZipCode} ${address.City} ${address.Region}`}
					</li>;
				})}
			</ul>
		</Flex.Item>
	</Flex.Vertical>;
}